























import { Component, Vue } from 'vue-property-decorator'
import LicenseTypeIframe from '@/components/ui/LicenseTypeIframe.vue'

@Component({
    components: { LicenseTypeIframe },
})
export default class Pipelines extends Vue {
    loading: boolean = false

    get links() {
        return [
            {
                label: 'Pijplijn & Fase',
                view: 'company_settings_pipelines_edit',
            },
            {
                label: 'Pijplijn werkgebied',
                view: 'company_settings_pipelines_operating_zones',
            },
            {
                label: 'Kanalen & bronnen',
                view: 'company_settings_pipelines_channels',
            },
            {
                label: 'Inkomende verbindingen',
                view: 'company_settings_pipelines_connections_incoming',
            },
            {
                label: 'Uitgaande verbindingen',
                view: 'company_settings_pipelines_connections_outgoing',
            },
        ]
    }

    get currentView() {
        return this.$route.name
    }
}
